import Point from 'ol/geom/Point';
import { buffer } from 'ol/extent';
export const convertPointToExtent = (point, distance = 0) => {
    const pointGeom = new Point(point);
    return buffer(pointGeom.getExtent(), distance);
};
//# sourceMappingURL=convertPointToExtent.js.map